module.exports = __webpack_public_path__ + "img/serve.612d9b0a.webp";